<script>
  import {link , push} from 'svelte-spa-router'
  import { _ } from "svelte-i18n";
  import UserStore from '../stores/user';

  export let back_link = '/';
  export let hide_back = false;

  let isMenuOpen = false;

  function toggleMenu() {
    isMenuOpen = !isMenuOpen;
  }

  const logOut = ()=> {

    UserStore.update(user=>{
      return {};
    })

    push('/login');

  }
  </script>
  
  <style>
    .back {
      display: block;
      padding: 10px 14px 0px;
      font-size: 22px;
    }
  </style>
  
  <div class="header">



    {#if $UserStore && $UserStore.data}  
    <nav class="mobile-nav">
      <button class="hamburger" on:click={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div class="overlay" id="overlay" on:click={toggleMenu} class:active={isMenuOpen}></div>
      <div class="nav-links" id="nav-links" class:active={isMenuOpen}>
        <ul>
          <li><a href="/history" use:link on:click={()=> { toggleMenu();}}>{$_('header.history')}</a></li>          
          <li><a class="logout" href="/" use:link on:click={()=> { toggleMenu(); logOut(); }}>{$_('header.logout')}</a></li>
        </ul>
      </div>
    </nav>
    {/if}

    <div class="logo">
      <a href="/" use:link><img src="images/logo.png" alt="Top Image" class="logo"></a>    
    </div>
    
    <a href="{back_link}" use:link class="back">{#if !hide_back}<i class="fas fa-arrow-left"></i>{/if}</a>
  </div>
  